.mandatory{color:#fb5b59}.not-mandatory{color:#fad948}
/*# sourceMappingURL=validation-warnings-icon-cell-viewer.component-USOCE7IL.css.map */
